import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = { class: "text-primary flex min-w-0 flex-1 items-center gap-2 px-4 font-semibold" }
const _hoisted_3 = { class: "truncate" }
const _hoisted_4 = {
  key: 0,
  class: "text-gray-400 transition-colors duration-150 hover:text-gray-600"
}
const _hoisted_5 = { class: "bg-primary rounded-tr p-1 text-white" }
const _hoisted_6 = { class: "flex-1 px-4 text-sm text-gray-600" }
const _hoisted_7 = { class: "text-primary flex items-center rounded-b border-t border-gray-300/50 px-4 py-2 text-sm font-semibold" }

import { PropType } from 'vue';
import type { Component } from 'vue';
import { Permission } from '@/types';
import { ArrowRightIcon, QuestionMarkCircleIcon } from '@heroicons/vue/solid';


export default /*@__PURE__*/_defineComponent({
  __name: 'UiDashboardLink',
  props: {
    routeName: {
        type: String,
        required: true,
    },
    permission: {
        type: String as PropType<Permission>,
        required: false,
    },
    title: {
        type: String,
        required: true,
    },
    description: {
        type: String,
        required: true,
    },
    tooltip: {
        type: String,
        required: false,
    },
    icon: {
        type: [Object, String, Function] as PropType<string | Component>,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (__props.permission && _ctx.$can(__props.permission))
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: { name: __props.routeName }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_UiPanel, {
            class: "flex min-h-full flex-col space-y-2 hover:bg-white",
            "no-padding": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h3", _hoisted_2, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(__props.title)), 1),
                  (__props.tooltip)
                    ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [
                        _createVNode(_unref(QuestionMarkCircleIcon), {
                          class: "h-4 w-4 cursor-help",
                          "aria-hidden": "true"
                        })
                      ])), [
                        [_directive_tippy, { content: _ctx.$t(__props.tooltip), allowHTML: true }]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(__props.icon), {
                    class: "h-8 w-8",
                    "aria-hidden": "true"
                  }))
                ])
              ]),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t(__props.description)), 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(ArrowRightIcon), {
                  class: "-ml-1 mr-1 h-4 w-4",
                  "aria-hidden": "true"
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('core.actions.goPage')), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"]))
    : _createCommentVNode("", true)
}
}

})